import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from "react-ga4";
import { hotjar } from 'react-hotjar';
import smartlookClient from 'smartlook-client';
import config from './config';
import App from './pages/app';
import './pages/app.less';
import { getCookie } from './services/cookies';

if (config.env === 'production') {
  Sentry.init({
    dsn: "https://edada690e15d44dc8aaf1633dc4f8239@o156308.ingest.sentry.io/4504101420728320",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.1,
    ignoreErrors: ['UnauthorizedError', '401'],
    environment: config.env,
  });

  hotjar.initialize(3203254, 6);

  if (hotjar.initialized()) {
    hotjar.identify('USER_ID', { userProperty: getCookie('email') });
  }

  smartlookClient.init('2a9449ea8ca21128c4b262d6e504976fbe8f0894');
  smartlookClient.identify(12345, {
    name: 'User',
    email: getCookie('email'),
  });

  ReactGA.initialize([
    {
      trackingId: "G-7D75QRG3E4",
      gaOptions: {
        userId: getCookie('email'),
      },
    },
  ]);
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
